import getFilterWithCol from '../../helpers/getFilterWithCol';

import { filterSortCreatedUpdatedName } from '../../components/common';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { name: { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search language by name',
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterCatalogue = ['FilterHidden', {
  id: 'filterCatalogue',
  build: builder => builder.add('custom', { catalogue: true }),
}];

export const ADMIN = [
  ...[
    [filterSearch, 12],
    [filterSortCreatedUpdatedName, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterCatalogue,
];
